/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Bold({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3.246 1.9a.5.5 0 0 1 .5-.5h3.792a3.37 3.37 0 0 1 2.446 5.687A3.832 3.832 0 0 1 8.923 14.6H3.746a.5.5 0 0 1-.5-.5V1.9Zm1.662 11.5H8.46a2.63 2.63 0 1 0 0-5.262H4.908V13.4Zm0-6.462h2.4a2.17 2.17 0 1 0 0-4.338h-2.4v4.338Z" clipRule="evenodd" /></svg>;
}
;